module.exports = __webpack_public_path__ + "bcc55a6b80b36fd2ab6966296f0d18e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fail.png
// module id = 194
// module chunks = 0